import { render } from "./StocklistItem.vue?vue&type=template&id=3160abda"
import script from "./StocklistItem.vue?vue&type=script&lang=js"
export * from "./StocklistItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__